document.addEventListener('DOMContentLoaded', () => {
    const reviewSections = document.querySelectorAll('.app-reviews');

    if (!reviewSections.length) return;

    reviewSections.forEach((reviewSection) => {
        const progressBar = reviewSection.querySelector('#progressBar');
        const wrappers = reviewSection.querySelectorAll('.review-card-wrapper');
        const intervalDuration = 7000;

        if (!wrappers.length) return;

        let currentIndex = 0;
        let startTime = performance.now();
        let animationFrameId;
        let intervalId;

        function showReview(index) {
            wrappers.forEach((wrapper) => wrapper.classList.remove('active'));
            wrappers[index]?.classList.add('active');
        }

        function updateProgressBar() {
            const elapsedTime = performance.now() - startTime;
            const progressValue = (elapsedTime / intervalDuration) * 100;

            if (progressBar) {
                progressBar.value = Math.min(progressValue, 100);
            }

            if (progressValue < 100) {
                animationFrameId = requestAnimationFrame(updateProgressBar);
            }
        }

        function nextReview() {
            currentIndex = (currentIndex + 1) % wrappers.length;
            showReview(currentIndex);
            startTime = performance.now();
            cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(updateProgressBar);
        }

        function initReviewSection() {
            showReview(currentIndex);
            updateProgressBar();
            intervalId = setInterval(nextReview, intervalDuration);
        }

        // Use IntersectionObserver to trigger init only when visible
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    initReviewSection();
                    obs.unobserve(entry.target); // Stop observing once initialized
                }
            });
        }, { threshold: 0.1 });

        observer.observe(reviewSection);
    });
});